<template>
  <div
    class="prepay-rate-ring"
    :class="{ 'prepay-rate-ring--custom-text': textSize !== null }"
    :style="{ '--rate-text-size': textSize + 'px' }"
  >
    <el-progress
      type="circle"
      :percentage="percent"
      :width="width"
      :stroke-width="strokeWidth"
      :color="color"
      :text-color="color"
      :format="formatText"
    />
    <div class="prepay-rate-ring__caption">
      <span>最终首付比</span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { getPrepayLevelColor } from "@/enum/dict";

export default {
  name: "PrepayRateRing",
  props: {
    // 首付比支持数字和数字字符串，缺失时显示 --。
    rate: {
      type: [Number, String],
      default: null,
    },
    // 等级只用于配色，未知等级使用兜底灰色。
    grade: {
      type: String,
      default: "",
    },
    // 圆环直径和线条宽度，单位均为 px。
    width: {
      type: Number,
      default: 120,
    },
    strokeWidth: {
      type: Number,
      default: 10,
    },
    textSize: {
      type: Number,
      default: null,
    },
  },
  computed: {
    // 保留实际数值，空白或非有限数值视为无数据。
    validRate() {
      const { rate } = this;
      if (
        rate === null ||
        rate === undefined ||
        (typeof rate === "string" && rate.trim() === "")
      )
        return null;
      const num = Number(rate);
      return Number.isFinite(num) ? num : null;
    },
    // 仅将绘制进度限制在 0～100，不修改展示值。
    percent() {
      return this.validRate === null
        ? 0
        : Math.min(100, Math.max(0, this.validRate));
    },
    // 环和数值共用等级配色。
    color() {
      return getPrepayLevelColor(this.grade);
    },
  },
  methods: {
    // 展示实际首付比，无数据时显示占位符。
    formatText() {
      return this.validRate === null ? "--" : String(this.validRate) + "%";
    },
  },
};
</script>

<style lang="scss" scoped>
.prepay-rate-ring {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &--custom-text /deep/ .el-progress__text {
    font-size: var(--rate-text-size) !important;
  }

  &__caption {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;

    /deep/ .el-button {
      font-size: inherit;
    }
  }
}
</style>
